import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProjectLocation = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "White",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		id: "Path_288",
		"data-name": "Path 288",
		d: "M1860.866,284.191a7.624,7.624,0,0,0-6.952-6.952v-2.572h-1.27v2.572a7.625,7.625,0,0,0-6.952,6.952h-2.571v1.27h2.571a7.624,7.624,0,0,0,6.952,6.952v2.572h1.27v-2.572a7.623,7.623,0,0,0,6.952-6.952h2.572v-1.27Zm-1.27,1.27a6.358,6.358,0,0,1-5.682,5.682v-2.507h-1.27v2.507a6.359,6.359,0,0,1-5.682-5.682h2.508v-1.27h-2.508a6.36,6.36,0,0,1,5.682-5.682v2.508h1.27v-2.508a6.359,6.359,0,0,1,5.682,5.682h-2.507v1.27Z",
		transform: "translate(-1841.121 -272.667)"
	}), /* @__PURE__ */ _jsx("rect", {
		id: "Rectangle_635",
		"data-name": "Rectangle 635",
		width: 24,
		height: 24,
		fill: "none"
	})]
});
export default SvgProjectLocation;
